import { createSlice } from '@reduxjs/toolkit'

import {
  fetchAllMapping,
  saveMapping,
  removeMapping,
  getMapping,
  updateMapping
} from '../services/Mapping.services'

type TInitialStateData = {
  loading: 'idle' | 'pending' | 'failed' | 'completed'
  error: null | string | undefined
  data: any
  totalData?: number
  navKeys?: any
  isNext?: boolean
  isPrev?: boolean
}

type TInitialState = {
  getall: TInitialStateData
  addnew: TInitialStateData
  getdata: TInitialStateData
  search: TInitialStateData
  delete: TInitialStateData
  isEditMode: boolean
  update: TInitialStateData
}
const initialStateData: TInitialStateData = {
  loading: 'idle',
  error: null,
  data: [],
  totalData: 0
}

const initialState: TInitialState = {
  getall: initialStateData,
  addnew: initialStateData,
  getdata: initialStateData,
  search: initialStateData,
  delete: initialStateData,
  isEditMode: false,
  update: initialStateData
}

const mapping = createSlice({
  name: 'mapping',
  initialState,
  reducers: {
    reset: (state, { payload }) => {
      switch (payload) {
        case 'addnew':
          state.addnew = initialStateData

          break
        case 'getdata':
          state.getdata = initialStateData
          state.isEditMode = false

          break
        case 'search':
          state.search = initialStateData

          break
        case 'delete':
          state.delete = initialStateData
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllMapping.pending, (state) => {
        state.getall.loading = 'pending'
        state.getall.error = null
        state.getall.data = []
      })
      .addCase(fetchAllMapping.fulfilled, (state, { payload }) => {
        if (payload.data) {
          state.getall.loading = 'completed'
          state.getall.data = payload.data
          state.getall.totalData = payload.total
          state.getall.error = null

          if (payload.key && payload.type === 'next') {
            state.getall.navKeys.push(payload.key)
            state.getall.isNext = true
            state.getall.isPrev = true
          } else if (payload.key && payload.type === 'prev') {
            state.getall.navKeys.pop()
            state.getall.isNext = true
            state.getall.isPrev = true
          } else if (!payload.key && payload.type === 'next') {
            state.getall.isNext = false
            state.getall.isPrev = true
          } else {
            state.getall.navKeys = []
            state.getall.isPrev = false

            if (payload.key === undefined) {
              state.getall.isNext = false
            } else {
              state.getall.isNext = true
              state.getall.navKeys.push(payload.key)
            }

            state.getall.totalData = payload.total
          }
        }
      })
      .addCase(fetchAllMapping.rejected, (state, { payload }) => {
        state.getall.loading = 'failed'
        state.getall.data = []
        state.getall.error = payload
      })

    builder
      .addCase(saveMapping.pending, (state) => {
        state.addnew.loading = 'pending'
        state.addnew.error = null
        state.addnew.data = ''
      })
      .addCase(saveMapping.fulfilled, (state) => {
        state.addnew.loading = 'completed'
        state.addnew.error = null
        state.addnew.data = ''
      })
      .addCase(saveMapping.rejected, (state, { payload }) => {
        state.addnew.loading = 'failed'
        state.addnew.error = payload
        state.addnew.data = ''
      })

    builder
      .addCase(removeMapping.pending, (state) => {
        state.delete.loading = 'pending'
        state.delete.error = null
        state.delete.data = ''
      })
      .addCase(removeMapping.fulfilled, (state) => {
        state.delete.loading = 'completed'
        state.delete.error = null
        state.delete.data = ''
      })
      .addCase(removeMapping.rejected, (state, { payload }) => {
        state.delete.loading = 'failed'
        state.delete.error = payload
        state.delete.data = ''
      })

    builder
      .addCase(getMapping.pending, (state) => {
        state.getdata.loading = 'pending'
        state.getdata.error = null
        state.getdata.data = []
      })
      .addCase(getMapping.fulfilled, (state, { payload }) => {
        if (payload.data) {
          state.getdata.loading = 'completed'
          state.getdata.data = payload.data
          state.getdata.error = null

          if (payload.editMode === true) {
            state.isEditMode = true
          }
        }
      })
      .addCase(getMapping.rejected, (state, { payload }) => {
        state.update.loading = 'failed'
        state.update.data = []
        state.update.error = payload
      })

      builder
      .addCase(updateMapping.pending, (state) => {
        state.update.loading = 'pending'
        state.update.error = null
        state.update.data = []
      })
      .addCase(updateMapping.fulfilled, (state, { payload }) => {
        if (payload.data) {
          state.update.loading = 'completed'
          state.update.data = payload.data
          state.update.error = null

          if (payload.editMode === true) {
            state.isEditMode = true
          }
        }
      })
      .addCase(updateMapping.rejected, (state, { payload }) => {
        state.update.loading = 'failed'
        state.update.data = []
        state.update.error = payload
      })
  }
})

export const { reset } = mapping.actions

export default mapping.reducer
